<template>
  <div v-if="visible" @click="onClick" :class="containerCss" :style="containerStyles">
    <doughnut-chart v-if="isDoughnutChart" v-on="$listeners" :chart-data="chartData" :options="options"/>
    <half-doughnut-chart v-if="isHalfDoughnutChart" v-on="$listeners" :chart-data="chartData" :options="options"/>
    <missing-part-doughnut-chart v-if="isMissingPartDoughnutChart" v-on="$listeners" :chart-data="chartData" :options="options"/>
  </div>
</template>

<script>
import DoughnutChart from './components/DoughnutChart.vue';
import HalfDoughnutChart from './components/HalfDoughnutChart.vue';
import { CHART_TYPES } from './constants';
import MissingPartDoughnutChart from './components/MissingPartDoughnutChart.vue';

export default {
  name: 'un-front-chart',
  components: { DoughnutChart, HalfDoughnutChart, MissingPartDoughnutChart },
  props: {
    visible: { type: Boolean, default: true },
    chartData: {
      type: Object,
      required: true,
      validator: (data) => !!data.datasets
    },
    chartOptions: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    refreshable: { type: Boolean, default: false },
    type: { type: String, required: true, validator: (chartType) => Object.values(CHART_TYPES).includes(chartType) },
    containerStyles: { type: Object, default: () => ({}) },
    // multichart: { type: Boolean, default: false }, // TODO
  },
  methods: {
    onClick(event) {
      event.preventDefault();
      if (this.clickable) this.$emit('click', event);
    },
    onRefresh(event) {
      event.preventDefault();
      if (this.refreshable) this.$emit('refresh', event);
    }
  },
  computed: {
    isDoughnutChart() {
      return this.type === CHART_TYPES.DOUGHNUT;
    },
    isHalfDoughnutChart() {
      return this.type === CHART_TYPES.HALF_DOUGHNUT;
    },
    isMissingPartDoughnutChart() {
      return this.type === CHART_TYPES.MISSING_PART_DOUGHNUT;
    },
    containerCss() {
      return {
        'clickable-chart': this.clickable,
        'un-front-chart-container': true
      };
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        ...this.chartOptions
      };
    }
  }
};
</script>

<style scoped>
.clickable-chart:hover {
  cursor: pointer;
}

.un-front-chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
